import { render } from "./PassUpdatePage.vue?vue&type=template&id=8d23704c"
import script from "./PassUpdatePage.vue?vue&type=script&lang=js"
export * from "./PassUpdatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__